'use client';

import { useEffect, useState } from 'react';

const useScreenSize = () => {
  const [screenDimensions, setScreenDimensions] = useState({ screenWidth: 0, screenHeight: 0 });

  const getScreenDimensions = () =>
    setScreenDimensions({
      screenWidth: document.body.offsetWidth,
      screenHeight: document.body.offsetHeight
    });

  useEffect(() => {
    getScreenDimensions();
    setScreenDimensions({
      screenWidth: document.body.offsetWidth,
      screenHeight: document.body.offsetHeight
    });
    window.addEventListener('resize', getScreenDimensions);
    return () => window.removeEventListener('resize', getScreenDimensions);
  }, []);

  return screenDimensions;
};

export default useScreenSize;
